import React, { useState } from 'react';
import { loginAdmin } from '../../api';

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = await loginAdmin({ email, password });
      onLogin(data.token);
    } catch (err) {
      setError('Invalid email or password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#131315] flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-[#1a1a1c] border border-gray-800 rounded-2xl p-8 shadow-2xl">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-Poppins font-bold text-[#f1edfd]">Admin Login</h2>
          <p className="text-gray-400 mt-2 text-sm font-Inter">Sign in to manage your portfolio</p>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-5">
          {error && (
            <div className="bg-red-500/10 border border-red-500/50 text-red-500 text-sm p-3 rounded-lg text-center">
              {error}
            </div>
          )}

          <div className="flex flex-col gap-2">
            <label className="text-[#f1edfd] text-sm font-medium">Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-[#131315] border border-gray-700 rounded-lg px-4 py-3 text-[#f1edfd] focus:outline-none focus:border-[#3aa1ff] transition-colors"
              placeholder="admin@portfolio.com"
              required
            />
          </div>

          <div className="flex flex-col gap-2">
            <label className="text-[#f1edfd] text-sm font-medium">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-[#131315] border border-gray-700 rounded-lg px-4 py-3 text-[#f1edfd] focus:outline-none focus:border-[#3aa1ff] transition-colors"
              placeholder="••••••••"
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#3aa1ff] hover:bg-[#288ce6] text-white font-medium py-3 rounded-lg transition-colors mt-4 disabled:opacity-70 flex justify-center items-center"
          >
            {loading ? (
              <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
            ) : (
              'Sign In'
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
